import { TableCell, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'

const CustomTooltip = ({ title, data, placement, color = "#444" }) => {
    const containerRef = useRef(null);
    const [isTextOverflowed, setIsTextOverflowed] = useState(false);
    useEffect(() => {
        const container = containerRef.current;
        setIsTextOverflowed(container.scrollWidth > container.clientWidth);
    }, []);
    return (
        <Tooltip title={title}
            disableHoverListener={!isTextOverflowed}
            PopperProps={{
                sx: {
                    "& .MuiTooltip-tooltip": {
                        backgroundColor: '#DAEDFE',
                        color: "#000",
                        minHeight: '26px',
                        display: 'flex',
                        fontWeight: '400',
                        alignItems: "center",
                        marginTop: '5px !important',
                        fontSize: '12px'
                    }
                }
            }}
            placement={placement}>
            <span ref={containerRef} style={{ color: color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: isTextOverflowed ? 'pointer' : '', textDecoration: isTextOverflowed ? "underline" : '' }}
                onMouseOut={(e) => e.currentTarget.style.color = isTextOverflowed ? '#444' : ''}
                onMouseOver={(e) => e.currentTarget.style.color = isTextOverflowed ? '#0086FF' : ''}
            >
                {data}
            </span>
        </Tooltip>
    )
}

export default CustomTooltip